/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./HeaderProfileDropdown.vue?vue&type=template&id=adad5f2e"
import script from "./HeaderProfileDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderProfileDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderProfileDropdown.vue?vue&type=style&index=0&id=adad5f2e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports